module.exports = __webpack_public_path__ + "img/thumb-miku.f6595558.png";